import Swiper from "swiper/bundle";

// init Swiper:

export default function initSwiper() {
	const imageSwiper = new Swiper('.testimonial-slider', {
		slidesPerView: 1,
		loop: true,
		effect: 'fade',

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

	const contentSwiper = new Swiper('.gallery-slider', {
		slidesPerView: 1,
		spaceBetween: 20,

		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		breakpoints: {
			992: {
				spaceBetween: 40,
			}
		}
	});

	const logoSwiper = new Swiper('.logo-slider', {
		spaceBetween: 0,
		speed: 2000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		loop: true,
		loopedSlides: 10,
		breakpoints: {
			640: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},
			992: {
				slidesPerView: 5,
			}
		}
	});
}